import { StandardEvents } from '@shopify/events';
const route=window.Shopify?.routes?.root||'/';
let requestSequence=0;
function render(cart){
 const bar=document.querySelector('[data-fdp-shipping-progress]');
 if(!bar||!cart)return;
 const currency=cart.currency||bar.dataset.currency;
 const country=bar.dataset.country;
 bar.hidden=currency!=='EUR'||!['FR','BE'].includes(country);
 if(bar.hidden)return;
 if(country==='BE'){
  bar.querySelector('[data-shipping-message]').textContent=bar.dataset.fixedText;
  delete bar.dataset.complete;
  return;
 }
 const threshold=Number(bar.dataset.threshold),total=Number(cart.total_price);
 if(!Number.isFinite(total)||!threshold)return;
 const remaining=Math.max(0,threshold-total);
 const amount=new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:'EUR'}).format(remaining/100);
 bar.querySelector('[data-shipping-message]').textContent=remaining?bar.dataset.remainingText.replace('__AMOUNT__',amount):bar.dataset.successText;
 bar.querySelector('[data-shipping-meter]').value=Math.min(100,Math.max(0,total/threshold*100));
 bar.dataset.complete=String(remaining===0);
}
async function refresh(){
 const seq=++requestSequence;
 try{
  const response=await fetch(route+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
  if(!response.ok)return;
  const cart=await response.json();
  if(seq===requestSequence)render(cart);
 }catch{}
}
document.addEventListener('fdp:cart-updated',event=>{++requestSequence;render(event.detail);});
document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
 if(event.promise)event.promise.then(refresh).catch(()=>{});
 else refresh();
});
window.addEventListener('pageshow',refresh);
document.addEventListener('shopify:section:load',refresh);
refresh();
